import './vendor/js/jquery.matchHeight-min.js';

import inView from 'in-view';

$(function(){
  scrollEvent();
  sortRandomHtml();
});

$(window).scroll(function () {
  scrollEvent();
});

function scrollEvent() {
  let $root,scrollY,headerHeight,MenuHeight;
  $root = $(document.documentElement);
  scrollY = $(window).scrollTop();

  if (scrollY > 20) {
    $root.attr('data-scrolled', true);
  } else {
    $root.attr('data-scrolled', false);
  }

  headerHeight = $('.js-header').outerHeight();
  MenuHeight = `calc(100% - ${headerHeight*2}px)`;
  /* $('.ssh-Secondary').css({'top':headerHeight,'height': MenuHeight});*/
}


function sortRandomHtml(){
  $('.js-sort-random').each(function(parentIndex) {
    let arr = [];
    let arr_child = [];
    let childrenVisible,random;
    $(this).children().each(function() {
      arr_child.push($(this).prop('outerHTML'));
    });

    arr_child.sort(function() {
      return Math.random() - Math.random();
    });

    arr[parentIndex] = arr_child;
    $(this).empty();
    for(let i=0; i < arr.length; i++) {
      $(this).append(arr[i]);
    }

    childrenVisible = $(this).children().filter(":visible").length;
    random = generationRandom(0,childrenVisible);
    $(this).children().filter(":visible").each(function (i) {
      let delayTime = random[i] / 10;
      $(this).css({'transition-delay': delayTime + 's'});
    });

  });
}

function generationRandom(min,max){
  let randoms = [];
  for(let i = min; i < max; i++){
    while(true){
      let tmp = Math.floor( Math.random() * (max - min + 1)) + min;
      if(!randoms.includes(tmp)){
        randoms.push(tmp);
        break;
      }
    }
  }
  return randoms;
}